/** @format */

import image01 from '../images/content-master/01.jpeg';
import imageWebp01 from '../images/content-master/01.webp';

import image02 from '../images/content-master/02.jpeg';
import imageWebp02 from '../images/content-master/02.webp';

import image03 from '../images/content-master/03.jpeg';
import imageWebp03 from '../images/content-master/03.webp';

import image04 from '../images/content-master/04.jpeg';
import imageWebp04 from '../images/content-master/04.webp';

import image05 from '../images/content-master/05.jpeg';
import imageWebp05 from '../images/content-master/05.webp';

import image06 from '../images/content-master/06.jpeg';
import imageWebp06 from '../images/content-master/06.webp';

import image07 from '../images/content-master/07.jpeg';
import imageWebp07 from '../images/content-master/07.webp';

import image08 from '../images/content-master/08.jpg';
import imageWebp08 from '../images/content-master/08.webp';

import image09 from '../images/content-master/09.jpeg';
import imageWebp09 from '../images/content-master/09.webp';

import image004 from '../images/content-master/004.png';
import imageWebp004 from '../images/content-master/004.webp';

import image005 from '../images/content-master/005.jpeg';
import imageWebp005 from '../images/content-master/005.webp';

import image008 from '../images/content-master/008.jpg';
import imageWebp008 from '../images/content-master/008.webp';

import nuevo1 from '../images/content-master/nuevo1.jpg';

import nuevo2 from '../images/content-master/nuevo2.jpg';
import nomo from '../images/content-master/nomo.jpg';
import nuevo3 from '../images/content-master/nuevo3.jpg';
import nuevo4 from '../images/content-master/nuevo4.jpg';
import nuevo5 from '../images/content-master/nuevo5.jpg';
import nuevo6 from '../images/content-master/nuevo6.jpg';
import tigre from '../images/content-master/tigre.jpeg';
import nika from '../images/content-master/Nika.jpg';
import niyale from '../images/content-master/Niyale.jpg';

const contentMaster = [
	{
		id: '01',
		title: 'Niyale escultura para impresión 3D',
		image: niyale,
		imageWebp: niyale,
		description: 'Escultura Digital en ZBRUSH desde cero a niveles avanzados.',
		video: 'https://www.youtube.com/watch?v=-aNxifGMNF0&ab_channel=LIBELACADEMY',
	},
	{
		id: '02',
		title: 'Escultura y Multi poses CC4',
		image: tigre,
		imageWebp: tigre,
		description:
			'Crearemos sorprendentes esculturas en ZBrush y utilizaremos Character creator 4 para crear Multi Poses para impresion 3D.',
		video: 'https://www.youtube.com/watch?v=-aNxifGMNF0&ab_channel=LIBELACADEMY',
	},
	{
		id: '03',
		title: 'Nika',
		image: nika,
		imageWebp: nika,
		description: 'domina el flujo de trabajo entre ZBrush y Cc4 para optimizar y crear personajes.',
	},
	{
		id: '04',
		title: 'El arte del detalle',
		image: nomo,
		imageWebp: nomo,
		description:
			'Aprende nuevas funciones y aplicaciones de detalles en ZBrush y recuerda que cada detalle cuenta.',
	},
	// {
	// 	id: '05',
	// 	title: 'Watto',
	// 	image: nuevo3,
	// 	imageWebp: nuevo3,
	// 	description: 'Escultura digital básica.',
	// },
	// {
	// 	id: '06',
	// 	title: 'Darth Talon',
	// 	image: nuevo4,
	// 	imageWebp: nuevo4,
	// 	description: 'Escultura digital básica con CC4.',
	// },
	// {
	// 	id: '07',
	// 	title: 'Ithorian',
	// 	image: nuevo5,
	// 	imageWebp: nuevo5,
	// 	description: 'Escultura digital intermedia.',
	// },
	{
		id: '05',
		title: 'AKI AKI',
		image: nuevo6,
		imageWebp: nuevo6,
		description: 'Escultura digital intermedia.',
	},
	{
		id: '06',
		title: 'Escultura Orgánica y Hardsurface',
		image: image008,
		imageWebp: imageWebp008,
		description:
			'Crea un sorprendente personaje femenino para coleccionables donde iremos más allá del personaje e implementaremos técnicas de escultura, organiza e inorgánica.',
	},
	// {
	// 	id: '10',
	// 	title: 'Escultura avanzada con ZBRUSH y REDSHIFT',
	// 	image: nuevo1,
	// 	imageWebp: nuevo1,
	// 	description:
	// 		'Entrenamiento especializado en escultura orgánica e inorgánica para personajes femeninos',
	// 	video: 'https://www.youtube.com/watch?v=wQyRCOU2Vvs',
	// },
	// {
	// 	id: '11',
	// 	title: 'NEON escultura HARDSURFACE con ZBRUSH y REDSHIFT',
	// 	image: nuevo2,
	// 	imageWebp: nuevo2,
	// 	description: 'Entrenamiento especializado en escultura Hardsurface para personajes masculinos',
	// 	video: 'https://www.youtube.com/watch?v=wQyRCOU2Vvs',
	// },
	// {
	// 	id: '12',
	// 	title: 'Escultura avanzada',
	// 	image: image08,
	// 	imageWebp: imageWebp08,
	// 	description: 'Crea este fantástico personaje desde cero usando técnicas avanzadas de ZBrush',
	// 	video: 'https://www.youtube.com/watch?v=p_pUkxvw_hQ',
	// },
	// {
	// 	id: '13',
	// 	title: 'Domina la escultura HARDSURFACE',
	// 	image: image09,
	// 	imageWebp: imageWebp09,
	// 	description: 'Aprende y desarrolla sorprendentes técnicas de escultura inorgánica en ZBRUSH ',
	// 	video: 'https://www.youtube.com/watch?v=RnFm-puWjYU',
	// },
	// {
	// 	id: '14',
	// 	title: 'Escultura Realista',
	// 	image: image004,
	// 	imageWebp: imageWebp004,
	// 	description:
	// 		'Crear modelos realistas es un gran reto que con nuestros entrenamiento lo podrás lograr, es momento de avanzaren tu carrera profesional.',
	// 	video: 'https://www.youtube.com/watch?v=k9U0_3eSyXA',
	// },
	// {
	// 	id: '15',
	// 	title: 'Escultura de fantástica',
	// 	image: image005,
	// 	imageWebp: imageWebp005,
	// 	description:
	// 		'Desarrollaremos esta excelente escultura en ZBrush donde aprenderás la importancia del detalle en la escultura digital .',
	// 	video: 'https://www.youtube.com/watch?v=x4p2eu-6U_Q',
	// },
	{
		id: '07',
		title: 'Gorila para Impresión',
		image: image01,
		imageWebp: imageWebp01,
		description:
			'Crea desde cero este increíble personaje con ZBrush y conoce el flujo de trabajo para impresión.',
		video: 'https://www.youtube.com/watch?v=8Gp-xi3XMjc',
	},
	{
		id: '08',
		title: 'Samurái y Dragon',
		image: image02,
		imageWebp: imageWebp02,
		description:
			'Junto con ZBruh y Marvelous Designer desarrollaremos este interesante modelo para impresión 3D desde cero.',
	},
	// {
	// 	id: '18',
	// 	title: 'Salamandra en ZBrush',
	// 	image: image04,
	// 	imageWebp: imageWebp04,
	// 	description:
	// 		'La práctica hace al maestro, con los siguientes modelos podrás pulir tu técnica acelerando tu flujo de trabajo.',
	// },
	{
		id: '09',
		title: 'Modelado HARDSURFACE',
		image: image05,
		imageWebp: imageWebp05,
		description:
			'Trabajemos en ZBrush  para crear modelos inorgánicos desde cero, agrégale un toque de creatividad e intenta dejarlo diferente.',
	},
	// {
	// 	id: '20',
	// 	title: 'Ejercicios HARDSURFACE',
	// 	image: image06,
	// 	imageWebp: imageWebp06,
	// 	description:
	// 		'Vamos de inicio a fin con modelos hardsurface  descubre lo que puedes lograr, no te saltes ningún contenido así aprenderás más rápido.',
	// },
	// {
	// 	id: '10',
	// 	title: 'Tigre en ZBrush',
	// 	image: image03,
	// 	imageWebp: imageWebp03,
	// 	description:
	// 		'En este proceso seguiremos descubriendo nuestro mejor flujo de trabajo para lograr increíbles resultados.',
	// },
	// {
	// 	id: '14',
	// 	title: 'Criaturas para impresión',
	// 	image: image07,
	// 	imageWebp: imageWebp07,
	// 	description:
	// 		'Cuando hallas realizado nuestros ejercicios, tendrás la capacidad de hacer cualquier modelo que desees en ZBrush.',
	// },
];

export default contentMaster;
